import {Button, CheckIcon} from '@kit';

import React from 'react';

import {LoginPopup} from '../../components/login-popup';
import {useToggle} from '../../components/utils/hooks';

import css from './sheets-promo.module.css';

const FEATURES = [
	'Пошаговое создание: вид, класс, предыстория и снаряжение из справочника',
	'Модификаторы, бонус умения, КБ, испытания и навыки считаются сами',
	'Заклинания, ячейки, отдыхи, пункты здоровья и испытания против смерти',
	'Хранится в вашем профиле и открывается с любого устройства',
];

const PREVIEW_ABILITIES = [
	{label: 'Сила', score: 16, modifier: '+3'},
	{label: 'Ловкость', score: 12, modifier: '+1'},
	{label: 'Выносливость', score: 15, modifier: '+2'},
	{label: 'Интеллект', score: 10, modifier: '+0'},
	{label: 'Мудрость', score: 13, modifier: '+1'},
	{label: 'Харизма', score: 8, modifier: '−1'},
];

const SheetPreview: React.FC = () => (
	<div className={css.preview} aria-hidden="true">
		<div className={css.previewHeader}>
			<span className={css.previewName}>Тордек</span>
			<span className={css.previewMeta}>Дварф · Воин 3</span>
		</div>
		<div className={css.previewStats}>
			<span>
				<b>18</b> КБ
			</span>
			<span>
				<b>28</b> ПЗ
			</span>
			<span>
				<b>+2</b> Бонус умения
			</span>
		</div>
		<div className={css.previewAbilities}>
			{PREVIEW_ABILITIES.map(({label, score, modifier}) => (
				<div key={label} className={css.previewAbility}>
					<span className={css.previewAbilityLabel}>{label}</span>
					<span className={css.previewModifier}>{modifier}</span>
					<span className={css.previewScore}>{score}</span>
				</div>
			))}
		</div>
	</div>
);

export const SheetsPromo: React.FC = () => {
	const [isLoginOpen, toggleLogin] = useToggle(false);

	return (
		<section className={css.promo} aria-labelledby="home-sheets">
			<div className={css.content}>
				<h2 id="home-sheets" className={css.title}>
					Бланки персонажей
				</h2>
				<p className={css.lead}>Электронный бланк, который учитывает правила 2024 года.</p>
				<ul className={css.features}>
					{FEATURES.map((feature) => (
						<li key={feature}>
							<CheckIcon className={css.check} width={16} height={16} />
							{feature}
						</li>
					))}
				</ul>
				<div className={css.actions}>
					<Button appearance="primary" route="registration">
						Зарегистрироваться
					</Button>
					<Button onClick={toggleLogin}>Войти</Button>
				</div>
			</div>
			<SheetPreview />
			{isLoginOpen && <LoginPopup onClose={toggleLogin} />}
		</section>
	);
};
